/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.alert-error\":\"Red octagon with white exclamation point\"}");